import Kemon0 from '../../../asset/myWorks/kemon/main.png';
import Kemon1 from '../../../asset/myWorks/kemon/addProduct.png';
import Kemon2 from '../../../asset/myWorks/kemon/chances.png';
import Kemon3 from '../../../asset/myWorks/kemon/dashboard.png';
import Kemon4 from '../../../asset/myWorks/kemon/Login.png';
import Kemon5 from '../../../asset/myWorks/kemon/accept_products.png';
import Kemon6 from '../../../asset/myWorks/kemon/profile.png';
import Kemon7 from '../../../asset/myWorks/kemon/services.png';
import Kemon8 from '../../../asset/myWorks/kemon/signup.png';
import Kemon9 from '../../../asset/myWorks/kemon/templates.png';
import Kemon10 from '../../../asset/myWorks/kemon/why_kemon.png';

// Jadstack
import Jadstack0 from '../../../asset/myWorks/jadstack/main.png';
import Jadstack1 from '../../../asset/myWorks/jadstack/about_jadstack.png';
import Jadstack2 from '../../../asset/myWorks/jadstack/footer.png';
import Jadstack3 from '../../../asset/myWorks/jadstack/solutions.png';

// Archsolve
import Archsolve0 from '../../../asset/myWorks/archsolve/main.png';
import Archsolve1 from '../../../asset/myWorks/archsolve/news_updates.png';
import Archsolve2 from '../../../asset/myWorks/archsolve/who_we_are.png';

//cider
import cider0 from '../../../asset/myWorks/cider/main.png';
import cider1 from '../../../asset/myWorks/cider/cloud_migration.png';
import cider2 from '../../../asset/myWorks/cider/capabilities.png';
import cider3 from '../../../asset/myWorks/cider/overview.png';

// Logos
import KemonLogo from '../../../asset/myWorks/Logo/kemonLG.png';
import jadstackLogo from '../../../asset/myWorks/Logo/jadstack.png';
import CiderLogo from '../../../asset/myWorks/Logo/cider_small.png';
import Archsolve from '../../../asset/myWorks/Logo/archsolveLogo2.png';

export const Kemon = [
    [
        { image: Jadstack0 },
        { image: Jadstack1 },
        { image: Jadstack2 },
        { image: Jadstack3 },
    ],

    [
        { image: cider0 },
        { image: cider1 },
        { image: cider2 },
        { image: cider3 },
    ],
    [{ image: Archsolve0 }, { image: Archsolve1 }, { image: Archsolve2 }],
    [
        { image: Kemon0 },
        { image: Kemon1 },
        { image: Kemon2 },
        { image: Kemon3 },
        { image: Kemon4 },
        { image: Kemon5 },
        { image: Kemon6 },
        { image: Kemon7 },
        { image: Kemon8 },
        { image: Kemon9 },
        { image: Kemon10 },
    ],
];

export const Logo = [
    {
        logo: jadstackLogo,
        name: 'Jadstack',
        url: 'https://jadstackcloud.com',
        desc: 'At Jadstack we focus on the unique nature of your business because we believe software should be designed for the business and not the other way around',
    },

    {
        logo: CiderLogo,
        name: 'Cider Global',
        url: 'https://ciderglobal.com',
        desc: 'We are the creative minds behind computer programs, High-performance infrastructure for cloud computing, data analytics & machine learning.',
    },

    {
        logo: Archsolve,
        name: 'Archsolve Clinicals',
        url: 'https://ciderglobal.com',
        desc: 'A One Year Open Label Study Assessing the Safety and Tolerability of Vilazodone in Patients With Major Depressive Disorder (MDD)',
    },
    {
        logo: KemonLogo,
        name: 'Kemon-market',
        url: 'https://kemon-market',
        desc: 'This is a platform that helps in showcasing your products online. You can also get search for any product from the nearest store.',
    },
];
